import { z } from 'zod';
import { PASSWORD_MAX_LENGTH, PASSWORD_MIN_LENGTH } from './password-rules.js';
/**
 * The Change password form's rules and messages, written once here so the
 * dashboard shows the same text whether it checks before sending or the API
 * refuses the request (`patterns/error-handling.md`, 3). The copy is the
 * user settings feature's `ux.md`.
 *
 * Neither password is ever trimmed or case-folded. The current password has
 * no length rule: one set before a rule changed must still be accepted as the
 * current one.
 */
const lengthRule = `Use ${PASSWORD_MIN_LENGTH} to ${PASSWORD_MAX_LENGTH} characters.`;
export const CHANGE_PASSWORD_FORM_MESSAGES = {
    currentPasswordRequired: 'Enter your current password.',
    currentPasswordWrong: 'Current password is wrong. Check it and try again.',
    newPasswordRequired: 'Enter a new password.',
    newPasswordTooShort: `New password is too short. ${lengthRule}`,
    newPasswordTooLong: `New password is too long. ${lengthRule}`,
};
/**
 * Piped rather than chained, so an empty new password reports only
 * "Enter a new password." and not the length rule as well. A missing field
 * gets the same message as an empty one.
 */
const newPasswordSchema = z
    .string({ error: CHANGE_PASSWORD_FORM_MESSAGES.newPasswordRequired })
    .min(1, { error: CHANGE_PASSWORD_FORM_MESSAGES.newPasswordRequired })
    .pipe(z
    .string()
    .min(PASSWORD_MIN_LENGTH, { error: CHANGE_PASSWORD_FORM_MESSAGES.newPasswordTooShort })
    .max(PASSWORD_MAX_LENGTH, { error: CHANGE_PASSWORD_FORM_MESSAGES.newPasswordTooLong }));
export const changePasswordFormSchema = z.object({
    currentPassword: z
        .string({ error: CHANGE_PASSWORD_FORM_MESSAGES.currentPasswordRequired })
        .min(1, { error: CHANGE_PASSWORD_FORM_MESSAGES.currentPasswordRequired }),
    newPassword: newPasswordSchema,
});
//# sourceMappingURL=change-password-form.js.map